import { ActionTypes } from "../../constants/ActionTypes";
import { IArchive, IEmployeePositionFolders, IFastArchiveModel, IItem } from "../../interfaces";

export const onGetPersonalArchiveFolders = (archiveId?: null | number) => {
    return {
        type: ActionTypes.GET_PERSONAL_ARCHIVE_FOLDERS,
        payload: archiveId,
    };
};

export const onSetPersonalArchive = (archiveModel: IArchive) => {
    return {
        type: ActionTypes.SET_PERSONAL_ARCHIVE,
        payload: archiveModel,
    };
};

export const onSetPersonalArchiveSuccess = () => {
    return {
        type: ActionTypes.SET_PERSONAL_ARCHIVE_SUCCESS,
    };
};

export const onSetOrganizationArchive = (archiveModel: IArchive) => {
    return {
        type: ActionTypes.SET_ORGANIZATION_ARCHIVE,
        payload: archiveModel,
    };
};

export const onSetOrganizationArchiveSuccess = () => {
    return {
        type: ActionTypes.SET_ORGANIZATION_ARCHIVE_SUCCESS,
    };
};

export const fetchPersonalArchiveFoldersSuccess = (
    archiveFolders: IEmployeePositionFolders[]
) => {
    return {
        type: ActionTypes.FETCH_PERSONAL_ARCHIVE_FOLDERS_SUCCESS,
        payload: archiveFolders,
    };
};

export const onGetOrganizationArchiveFolders = (
    organizationArchiveId?: null | number
) => {
    return {
        type: ActionTypes.GET_ORGANIZATION_ARCHIVE_FOLDERS,
        payload: organizationArchiveId,
    };
};

export const fetchOrganizationArchiveFoldersSuccess = (
    organizationArchiveFolders: IEmployeePositionFolders[]
) => {
    return {
        type: ActionTypes.FETCH_ORGANIZATION_ARCHIVE_FOLDERS_SUCCESS,
        payload: organizationArchiveFolders,
    };
};

export const changeArchiveStateItemsValue = (item: IItem) => {
    return {
        type: ActionTypes.CHANGE_ARCHIVE_STATE_ITEMS_VALUE,
        payload: item,
    };
};

export const onFastArchive = (fastArchiveModel: IFastArchiveModel) => {
    return {
        type: ActionTypes.FAST_ARCHIVE,
        payload: fastArchiveModel,
    };
};

export const onFastArchiveSuccess = () => {
    return {
        type: ActionTypes.FAST_ARCHIVE_SUCCESS,
    };
};
